"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signup = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const input_state_1 = require("../../components/input/input.state");
const input_state_group_1 = require("../../components/input/input.state.group");
const mithril_component_1 = require("../../components/mithril.component");
const submit_button_1 = require("../../components/submit.button");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const classnames_1 = require("../../util/classnames");
const auth_component_style_1 = require("../auth/auth.component.style");
const migrate_user_1 = require("../auth/migrate.user");
const signup_style_1 = require("./signup.style");
(0, theme_1.addStyles)(signup_style_1.Style);
function checkValidity(input, msg) {
    if (!input.isFilled) {
        input.setError(msg);
    }
    else {
        input.setError('');
    }
}
class Signup extends mithril_component_1.IMithrilStateComponent {
    constructor(ctrl, inviteToken) {
        super();
        this.form = new input_state_group_1.IkeInputStateGroup();
        this.firstName = new input_state_1.InputState(index_1.T.SIGNUP_FIRST_NAME);
        this.lastName = new input_state_1.InputState(index_1.T.SIGNUP_LAST_NAME);
        this.firstNameValue = null;
        this.lastNameValue = null;
        this.ctrl = ctrl;
        this.inviteToken = inviteToken;
        this.autorun(_ => this.validate());
    }
    get nodes() {
        return (0, mithril_1.m)('form', { className: auth_component_style_1.CSS.container }, [
            // First Name
            (0, mithril_1.m)('input', {
                className: (0, classnames_1.classNames)(migrate_user_1.CSS.emailInput, {
                    [migrate_user_1.CSS.emailInputHasError]: typeof this.firstNameValue === 'string' ? !Boolean(this.firstNameValue) : false
                }),
                placeholder: (0, index_1.Translate)(index_1.T.SIGNUP_FIRST_NAME),
                onkeyup: (event) => {
                    this.firstNameValue = event.target.value;
                },
                value: this.firstNameValue,
                disabled: this.ctrl.loading
            }),
            this.getValidationError(this.firstNameValue, index_1.T.SIGNUP_FIRST_NAME_INVALID),
            // Last Name
            (0, mithril_1.m)('div', { className: auth_component_style_1.CSS.padding }, (0, mithril_1.m)('input', {
                className: (0, classnames_1.classNames)(migrate_user_1.CSS.emailInput, {
                    [migrate_user_1.CSS.emailInputHasError]: typeof this.lastNameValue === 'string' ? !Boolean(this.lastNameValue) : false
                }),
                placeholder: (0, index_1.Translate)(index_1.T.SIGNUP_LAST_NAME),
                onkeyup: (event) => {
                    this.lastNameValue = event.target.value;
                },
                value: this.lastNameValue,
                disabled: this.ctrl.loading
            })),
            this.getValidationError(this.lastNameValue, index_1.T.SIGNUP_LAST_NAME_INVALID),
            (0, mithril_1.m)('div', { className: auth_component_style_1.CSS.padding }, submit_button_1.SubmitButton.view({
                title: index_1.T.SIGNUP,
                form: this.form,
                submit: this.submit,
                submitting: this.ctrl.loading,
                disabled: !Boolean(this.firstNameValue) || !Boolean(this.lastNameValue),
                className: auth_component_style_1.CSS.button,
                noAccent: true
            }))
        ]);
    }
    getValidationError(value, error) {
        if (typeof value === 'string' ? Boolean(value) : true) {
            return null;
        }
        return (0, mithril_1.m)('div', {
            className: migrate_user_1.CSS.validationError
        }, (0, index_1.Translate)(error));
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!Boolean(this.firstNameValue) || !Boolean(this.lastNameValue)) {
                services_1.Logger.error('Attempted to submit invalid form...');
                return;
            }
            yield this.ctrl.signupSSO(this.inviteToken, this.firstNameValue, this.lastNameValue);
            return;
        });
    }
    validate() {
        checkValidity(this.firstName, index_1.T.SIGNUP_FIRST_NAME_INVALID);
        checkValidity(this.lastName, index_1.T.SIGNUP_LAST_NAME_INVALID);
    }
}
exports.Signup = Signup;
tslib_1.__decorate([
    mobx_1.observable
], Signup.prototype, "firstNameValue", void 0);
tslib_1.__decorate([
    mobx_1.observable
], Signup.prototype, "lastNameValue", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], Signup.prototype, "submit", null);
//# sourceMappingURL=signup.js.map